import {
  UtensilsCrossed,
  Coffee,
  Scissors,
  Sparkles,
  Flower2,
  Hotel,
  BedDouble,
  Dumbbell,
  Stethoscope,
  Wrench,
  ShoppingBag,
  Store,
} from "lucide-react";
import { Reveal } from "@/lib/motion";

const CATS = [
  { icon: UtensilsCrossed, label: "Restaurants" },
  { icon: Coffee, label: "Cafés" },
  { icon: Scissors, label: "Barbers" },
  { icon: Sparkles, label: "Hair Salons" },
  { icon: Flower2, label: "Beauty Salons" },
  { icon: Hotel, label: "Hotels" },
  { icon: BedDouble, label: "B&Bs" },
  { icon: Dumbbell, label: "Gyms" },
  { icon: Stethoscope, label: "Clinics" },
  { icon: Wrench, label: "Garages" },
  { icon: ShoppingBag, label: "Retail Stores" },
  { icon: Store, label: "Local Businesses" },
];

export const UseCases = () => (
  <section className="bg-white py-24 md:py-32" data-testid="use-cases-section">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <Reveal>
        <p className="text-overline">Where it belongs</p>
        <h2 className="mt-4 max-w-2xl font-display text-4xl font-medium tracking-tight text-ink sm:text-5xl">
          Made for businesses that meet customers every day.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {CATS.map((c, i) => (
          <Reveal key={c.label} delay={(i % 4) * 0.06}>
            <div className="group flex items-center gap-4 rounded-2xl border border-black/5 bg-sand p-5 transition-transform duration-300 hover:-translate-y-1">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white text-ink shadow-sm">
                <c.icon className="h-5 w-5" strokeWidth={1.5} />
              </span>
              <span className="text-sm font-medium text-ink">{c.label}</span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
